<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Prodotti',
      link: '/prodotti'
    }, {
      label: form.uuid ? 'Modifica Prodotto' : 'Aggiungi nuova Prodotto'
    }]"
  />
  <form autocomplete="off">
    <InputText
      v-model="form.code"
      :error-fields="errorFields"
      name="code"
      :submitted="submitted"
    >
      Code
    </InputText>

    <InputTextarea
      v-model="form.multilangName"
      :error-fields="errorFields"
      help="{ &quot;it&quot; : &quot;Nome in italiano&quot;, &quot;en&quot; : &quot;Name in english&quot; }"
      name="multilangName"
      :submitted="submitted"
    >
      Nome localizzato
    </InputTextarea>

    <InputTextarea
      v-model="form.multilangDesc"
      :error-fields="errorFields"
      help="{ &quot;it&quot; : &quot;Descrizione in italiano&quot;, &quot;en&quot; : &quot;Description in english&quot; }"
      name="multilangDesc"
      :submitted="submitted"
    >
      Descrizione localizzata
    </InputTextarea>

    <InputInteger
      v-model="form.maxQuantityPercentage"
      :error-fields="errorFields"
      name="maxQuantityPercentage"
      :submitted="submitted"
    >
      Percentuale Quantità massima
    </InputInteger>

    <InputInteger
      v-model="form.maxGroupQuantityPercentage"
      :error-fields="errorFields"
      name="maxGroupQuantityPercentage"
      :submitted="submitted"
    >
      Percentuale Quantità massima per Gruppi
    </InputInteger>

    <InputInteger
      v-model="form.tolerance"
      :error-fields="errorFields"
      name="tolerance"
      :submitted="submitted"
    >
      Percentuale Tolleranza
    </InputInteger>

    <InputInteger
      v-model="form.groupTolerance"
      :error-fields="errorFields"
      name="groupTolerance"
      :submitted="submitted"
    >
      Percentuale Tolleranza per Gruppi
    </InputInteger>

    <CategoryInputSelect
      v-model="form.categoryUuid"
      :error-fields="errorFields"
      name="categoryUuid"
      :submitted="submitted"
    >
      Categoria
    </CategoryInputSelect>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>

<script setup>
import { reactive } from "vue";

import CategoryInputSelect from "@/components/form/CategoryInputSelect.vue";
import InputInteger from "@/components/form/InputInteger.vue";
import InputText from "@/components/form/InputText.vue";
import InputTextarea from "@/components/form/InputTextarea.vue";
import SubmitButtons from "@/components/form/SubmitButtons.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from "@/composables/axios";
import useForm from "@/composables/form";
import Validation from "@/services/validation";

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  },
});

const axios = useAxios();

let form = reactive({
  code: "",
  maxQuantityPercentage: null,
  maxGroupQuantityPercentage: null,
  tolerance: null,
  groupTolerance: null,
  categoryUuid: null,
  multilangName: '',
  multilangDesc: ''
});

if (props.id) {
  const resp = await axios.get("/product/" + props.id);
  form = reactive(resp.data);
}

const rules = {
  code: {
    type: "string",
    max: 12,
    required: true,
  },
  multilangName: {
    type: "string",
    required: true,
    validator: Validation.isJson
  },
  multilangDesc: {
    type: "string",
    required: true,
    validator: Validation.isJson
  },
  maxQuantityPercentage: {
    type: "integer",
    required: true,
    min: 0,
    max: 100
  },
  maxGroupQuantityPercentage: {
    type: "integer",
    required: true,
    min: 0,
    max: 100
  },
  tolerance: {
    type: "integer",
    required: true,
    min: 0,
    max: 100
  },
  groupTolerance: {
    type: "integer",
    required: true,
    min: 0,
    max: 100
  },
  categoryUuid: {
    type: "string",
    required: true,
  }
};

const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'product', rules, {
  create: 'Prodotto creato con successo',
  update: 'Prodotto modificato con successo'
}, '/prodotti', () => {
  form.code = ''
  form.multilangName = ''
  form.multilangDesc = ''
  form.categoryUuid = null
  form.maxQuantityPercentage = null
  form.maxGroupQuantityPercentage = null
  form.tolerance = null
  form.groupTolerance = null
})

</script>
